<template>
  <div :class="'gauge-indice total-' + total">
    <span
      v-for="c in total"
      :key="'gi_' + c"
      :class="c <= value ? 'active' : ''"
    ></span>
  </div>
</template>

<script>
export default {
  name: "Gauge",
  components: {},
  props: {
    value: Number,
    total: {
      type: Number,
      default: 10,
    },
  },
  watch: {},
  computed: {},
  methods: {},
  mounted() {},
};
</script>
